import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as weatherService from '_services/weather-service';

const initialState = {
    weather: null,
    image: '',
    status: 'idle',
    statusObj: {},
    error: null
};

/* get weather and forecast */
export const getWeather = createAsyncThunk('weather/getWeather', async (iata) => {
    return weatherService.getWeather(iata);
});

export const getImage = createAsyncThunk('weather/getImage', async (iata) => {
    return weatherService.getImage(iata);
});


const weatherSlice = createSlice({
    name: 'weather',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [getWeather.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
              statusObj: { ...state.statusObj, getWeather :"loading" }
            }
        },
        [getWeather.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              statusObj: { ...state.statusObj, getWeather :"succeeded" },
              weather: action.payload
            }
        },
        [getWeather.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              statusObj: { ...state.statusObj, getWeather :"failed" },
              error: action.error.message
            }
        },
        [getImage.pending]: (state, action) => {
            return {
              ...state,
              statusObj: { ...state.statusObj, getImage :"loading" },
            }
        },
        [getImage.fulfilled]: (state, action) => {
            return {
              ...state,
              image: action.payload,
              statusObj: { ...state.statusObj, getImage :"succeeded" },
            }
        },
        [getImage.rejected]: (state, action) => {
            return {
              ...state,
              statusObj: { ...state.statusObj, getImage :"failed" },
              image: '',
              error: action.error.message
            }
        },
    }
});


function capitalizeEveryWord(str) {
    var words = str.toLowerCase().split(' ');
  
    for (var i = 0; i < words.length; i++) {
      var letters = words[i].split('');
      letters[0] = letters[0].toUpperCase();
      words[i] = letters.join('');
    }
  
    return words.join(' ');
}

export const selectCurrentForecast = state => {
    if(state.weather.weather == undefined || state.weather.weather == null || state.weather.weather == {}){ return []}

    let newObject = {}

    if(state.weather.weather['weatherForecast']){

        let oldphrase = state.weather.weather['weatherForecast'][0]['phrase']
        let phrase = capitalizeEveryWord(oldphrase)

        newObject['lowestTemperature'] = state.weather.weather['weatherForecast'][0]['lowTemperatureValue']
        newObject['highestTemperature'] = state.weather.weather['weatherForecast'][0]['highTemperatureValue']
        newObject['percipitationProbability'] = state.weather.weather['weatherForecast'][0]['probabilityOfPrecip']
        newObject['phrase'] = phrase
        newObject['nightPhrase'] = state.weather.weather['weatherForecast'][0]['nightPhrase']
    }
    else { return []}

    return newObject;
}

export const selectForecast = state => {
    if(state.weather.weather == undefined || state.weather.weather == null || state.weather.weather['weatherForecast'] == undefined || state.weather.weather['weatherForecast'] == null || state.weather.weather == {}){ return []}

    let returnObject = {};

    let weatherObject = state.weather.weather['weatherForecast'];

    weatherObject.forEach((weather) => {
        returnObject[weather.forecastDate] = weather;
    })
    
    return returnObject;
}


export const { reset } = weatherSlice.actions;
export const selectWeather = state => state.weather.weather;
export const selectWeatherStatus = state => state.weather.status;
export const selectImageStatus = state => state.weather.statusObj?.["getImage"];
export const selectImage = state => state.weather.image;
export default weatherSlice.reducer;
